import client from '../http_client';
import { parseList } from './parsing';
import { LiveBenchmarksResponse } from './types';

const root = '/v1/live-benchmarking';

export class BenchmarkingService {
  public static async getLiveBenchmarks(startDate: Date): Promise<LiveBenchmarksResponse> {
    const response = await client.get<LiveBenchmarksResponse>(
      `${root}/live-benchmarks?start_time=${startDate.toISOString()}`,
      { transformResponse: parseList, timeout: 90000 },
    );
    return response.data;
  }
}
